import React, {useState} from "react";
import {Button, Form} from "react-bulma-components";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import FAIcon from "../Icon/FAIcon";
import WorkTypePicker from "../Job/WorkTypePicker";
import {createSetDataFreshAction, createSetWorkDataAction} from "../../actions/dataActions";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import {expenseDueDate, formatDate, readableDate} from "../../utils";
import {useDispatch} from "react-redux";




export default function StageChangeRow({dataFresh,endpoint, work, view, onWorkSave, index, workTypes, workTypeObjects, nominalCodes, codeObjects, onPartSave, trackingOptions, trackingOptionObjects, onAmountPaidSave}){
    const [editable, setEditable] = useState(false);
    const [paidEditable, setPaidEditable] = useState(false);
    const [partEditable, setPartEditable] = useState(false);
    const [workState, setWorkState] = useState(work);

    const onPaidSave = (work, customerPaidAmount) => {
        onAmountPaidSave(work, customerPaidAmount).then(res => {
            setPaidEditable(false)
        })
    }
    const onChange = e => {
        //e.stopPropagation();
        let newWork = {...workState};
        newWork[e.target.name] = e.target.value;
        setWorkState(newWork);
    };

    const handleDueDate = () => {
        let date = expenseDueDate(workState, "workshop_invoice_date", "workshop_details");
        if(date){
          return readableDate(formatDate(date));
        }
        else{
          return ""
        }
    }



    const handlePartSave = (partIndex, work) => {
        onPartSave(partIndex, work);
        setPartEditable(false);
    }
    const onPartChange = (e, workItem, partIndex) => {
      let newParts = [...workItem.parts];
      newParts[partIndex][e.target.name] = e.target.value;
      const toUpdate = {
          target: {
              name: "parts",
              value: newParts
          }
      };
      onChange(toUpdate);
    }

    const onPartCustomerPaidChange = (e, workItem, partIndex) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !workItem.parts[partIndex][e.target.name]
            }
        };
        console.log(toUpdate)
        onPartChange(toUpdate, workItem, partIndex);
    }


    const onPartNominalChange = (e, workItem, partIndex) =>{
      const toUpdate = {
          target: {
              name: e.target.name,
              value: codeObjects[e.target.value]
          }
      };
      onPartChange(toUpdate, workItem, partIndex)
    }

    const onPartTrackingOptionChange = (e, workItem, partIndex) =>{
      const toUpdate = {
          target: {
              name: e.target.name,
              value: trackingOptionObjects[e.target.value]
          }
      };
      onPartChange(toUpdate, workItem, partIndex)
    }

    const onNominalChange = e => {
      e.stopPropagation();
      let newWork = {...workState};
      newWork[e.target.name] = codeObjects[e.target.value];
      setWorkState(newWork);
    }

    const onTrackingOptionChange = e => {
        e.stopPropagation();
        let newWork = {...workState};
        newWork[e.target.name] = trackingOptionObjects[e.target.value];
        setWorkState(newWork)
    }

    const onCheck = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !workState.customer_pre_paid
            }
        }
        onChange(toUpdate);
    }
    /*
    const onInvoiceNumberChange = e => {
        //Call correct function
        //Call normal onChange to update state
        // view === "po" ? (e) => updateWorkshopInvoiceValue(index, e.target.value) : workState.chargeable ? (e) => updateHireCustomerInvoiceValue(index, e.target.value) : (e) => updateCustomerInvoiceValue(index, e.target.value)
        if(view === 'po'){
            updateWorkshopInvoiceValue(index, e.target.value);
        }
        if(view === 'invoice'){
            if(workState.chargeable){
                updateHireCustomerInvoiceValue(index, e.target.value);
            }
            else {
                updateCustomerInvoiceValue(index, e.target.value);
            }
        }
        onChange(e);
    }
    */

    const onWorkTypeChange = e => {
        e.stopPropagation();
        let newWork = {...workState};
        newWork[e.target.name] = workTypeObjects[e.target.value];
        setWorkState(newWork);
    }
    let rows = [];
    let invoiceNumberName = view ==="po" ? (workState.labour_cost < 0) ? "job_workshop_credit_number" : 'job_workshop_invoice_number' : workState.chargeable ? 'job_customer2_invoice_number' : 'job_customer_invoice_number';
    let invoiceNumberValue = view ==="po" ? (workState.labour_cost < 0) ? workState.job_workshop_credit_number : workState.job_workshop_invoice_number : workState.chargeable ? workState.job_customer2_invoice_number : workState.job_customer_invoice_number;

    const firstRow = (
        <tr
            key={workState.id}
        >
            <td>{workState.job ? workState.job : ""}</td>
            <td>{workState.description}</td>
            {useEditableTableTextAreaCell({
              propName: "invoice_comments",
              value: workState.invoice_comments,
              onChange: onChange,
              onSave: () => onWorkSave(workState, setEditable, view),
              editable,
              setEditable,
              inlineEdit: true,
              disabled: view === 'po' ? work.po_approved : work.invoice_approved
            })}
            <td>£{workState.labour_cost}</td>
            <td>£{workState.customer_labour_cost}</td>
            {useEditableTableTextCell({
                propName: invoiceNumberName,
                value: invoiceNumberValue,
                onChange: onChange,
                onSave: () => onWorkSave(workState, setEditable, view),
                editable,
                setEditable,
                inlineEdit: true,
                disabled: view === 'po' ? workState.po_approved : workState.invoice_approved

            })}
            <td>
                <NominalCodePicker
                    name={view==="po" ? "supplier_nominal_code" : "customer_nominal_code"}
                    onChange={onNominalChange}
                    onSave={() => onWorkSave(workState, setEditable, view)}
                    options={nominalCodes}
                    inlineEdit={true}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    value={view === "po" ? workState.supplier_nominal_code : workState.customer_nominal_code}
                    disabled={!editable}
                />
            </td>
            <td>
                <TrackingOptionsPicker
                    options={trackingOptions}
                    value={view === "po" ? workState.supplier_tracking_option : workState.customer_tracking_option}
                    disabled={!editable}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    inlineEdit={true}
                    onChange={onTrackingOptionChange}
                    onSave={() => onWorkSave(workState, setEditable, view)}
                    name={view === "po" ? "supplier_tracking_option" : "customer_tracking_option"}
                />
            </td>
            {view === "invoice" &&
                <td>
                    <Form.Field className={"has-addons"}>
                        <Form.Control>
                            <Form.Input
                                name={"customer_paid_amount"}
                                value={workState.customer_paid_amount}
                                disabled={!paidEditable}
                                onChange={onChange}
                            />
                        </Form.Control>
                        {paidEditable ? (<Form.Control>
                            <Button
                              className="small-row-white"
                              color="success"
                              onClick={e => onPaidSave(workState, workState.customer_paid_amount)}
                            >
                              <FAIcon size="small" icon={["fas", "save"]}></FAIcon>
                            </Button>
                          </Form.Control>
                        ) : (
                          <Form.Control>
                            <Button
                              className="small-row-black"
                              onClick={() => setPaidEditable(!paidEditable)}
                              disabled={!workState.job}
                            >
                              <FAIcon size="small" icon={["fas", "edit"]}/>
                            </Button>
                          </Form.Control>)}
                    </Form.Field>
                </td>
            }
            {/*{view === "po" &&*/}
            {/*    <td onClick={e => e.stopPropagation()}>*/}
            {/*        <Form.Field className={"has-addons"}>*/}
            {/*            <Form.Control>*/}
            {/*                <Form.Input*/}
            {/*                    type={"date"}*/}
            {/*                    onChange={onChange}*/}
            {/*                    name={"job_workshop_payment_date"}*/}
            {/*                    value={workState.job_workshop_payment_date}*/}
            {/*                    disabled={!editable}*/}
            {/*                />*/}
            {/*            </Form.Control>*/}
            {/*            {editable ? (*/}
            {/*                <Form.Control>*/}
            {/*                  <Button color="success" onClick={() => onWorkSave(workState, setEditable, view)}>*/}
            {/*                    <FAIcon size="small" icon={["fas", "save"]}></FAIcon>*/}
            {/*                  </Button>*/}
            {/*                </Form.Control>*/}
            {/*              ) : (*/}
            {/*                <Form.Control>*/}
            {/*                  <Button onClick={()=> setEditable(true)}>*/}
            {/*                      <FAIcon size="small" icon={["fas", "edit"]}/>*/}
            {/*                  </Button>*/}
            {/*                </Form.Control>*/}
            {/*            )}*/}
            {/*        </Form.Field>*/}
            {/*    </td>*/}
            {/*}*/}
            {view === 'po' &&
                <td onClick={e => e.stopPropagation()}>
                    <WorkTypePicker
                        options={workTypes}
                        work={workState}
                        disabled={!editable}
                        editable={editable}
                        setEditable={setEditable}
                        showTitle={false}
                        onSave={() => onWorkSave(workState, setEditable, view, index)}
                        onSelect={(e) => onWorkTypeChange(e, index)}
                    />
                </td>
            }
            {view === 'po' && <td>{handleDueDate()}</td>}
            <td>
                <Button
                    color={"warning"}
                    onClick={() => window.open(`/editjob/${work.job}`, "_self")}
                >
                    Go To Job
                </Button>
            </td>
        </tr>
    )
    rows.push(firstRow);

    const secondRow = work.parts.map((part, index) => {
        return (
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>PART: {part.id}</td>
                <td>{part.name}</td>
                <td></td>
                <td>
                    <NominalCodePicker
                        value={view === "po" ? part.supplier_nominal_code : part.customer_nominal_code}
                        options={nominalCodes}
                        blank={true}
                        name={view === "po" ? "supplier_nominal_code" : "customer_nominal_code"}
                        disabled={!partEditable}
                        editable={partEditable}
                        setEditable={setPartEditable}
                        inlineEdit={true}
                        onSave={() => {
                            handlePartSave(index, work);
                            setPartEditable(false);
                        }}
                        onChange={(e) => onPartNominalChange(e, work, index)}
                    />
                </td>
                <td>
                    <TrackingOptionsPicker
                        options={trackingOptions}
                        value={view === "po" ? part.supplier_tracking_option : part.customer_tracking_option}
                        name={view === "po" ? "supplier_tracking_option" : "customer_tracking_option"}
                        disabled={!partEditable}
                        editable={partEditable}
                        setEditable={setPartEditable}
                        inlineEdit={true}
                        blank={true}
                        onSave={() => {
                            handlePartSave(index, work);
                            setPartEditable(false);
                        }}
                        onChange={(e) => onPartTrackingOptionChange(e, work, index)}
                    />
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        )
    })
    rows = rows.concat(secondRow);
    return rows



}